import { useTranslation } from 'react-i18next'

import { Alert, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import CarrierSelector from '@/common/components/CarrierSelector/CarrierSelector'

import { errorTypes } from '../constants'
import * as Styles from './styles'

const ShippingMethodLogistic = ({ carrierSelected, carriers, onChange, deliveryDaysRange, errors = [] }) => {
  const { t } = useTranslation()

  const handleChangeCarrier = carrier => {
    onChange({ carrier })
  }

  const handleChangeDeliveryDays = (event, deliveryDaysType) => {
    const deliveryDays = event.target.value.replace(/[^0-9]/g, '')
    onChange({
      delivery_days_range: {
        ...deliveryDaysRange,
        [deliveryDaysType]: deliveryDays,
      },
    })
  }

  const shouldShowAlert = () => {
    return carriers?.find(carrier => carrier?.id === carrierSelected)?.is_reveni_contract
  }

  const isPickupPoint = () => {
    return carriers?.find(carrier => carrier?.id === carrierSelected)?.is_pickup_point
  }

  return (
    <Styles.Container id={errorTypes.carrierEmpty}>
      <Text type="titleS">{t('Logística')}</Text>
      <CarrierSelector carriers={carriers} value={carrierSelected} onChange={handleChangeCarrier} errors={errors} />
      {isPickupPoint() && (
        <Alert type="info">
          {t(
            'Este método de envío utiliza puntos de recogida (pickup points). En el checkout, el cliente podrá elegir un punto de entrega y el pedido se creará con la dirección de ese punto como destino.'
          )}
        </Alert>
      )}
      <Styles.DeliveryDaysContainer>
        <Text type="bodyMRegular">{t('Días naturales estimados de entrega')}</Text>
        <Styles.DeliveryDaysRange>
          <InputWithLabel
            label={t('Mínimo')}
            value={deliveryDaysRange?.lower}
            onChange={event => handleChangeDeliveryDays(event, 'lower')}
            fullWidth
          />
          <InputWithLabel
            label={t('Máximo')}
            value={deliveryDaysRange?.upper}
            onChange={event => handleChangeDeliveryDays(event, 'upper')}
            fullWidth
          />
        </Styles.DeliveryDaysRange>
      </Styles.DeliveryDaysContainer>
      {shouldShowAlert() && (
        <Alert type="info">
          {t(
            'Para evitar problemas de re-importación y aduanas, para las devoluciones internacionales de pedidos enviados con este método, cuando sea posible se limitarán los métodos de devolución disponibles en el portal a aquellos que utilicen el mismo transportista.'
          )}
        </Alert>
      )}
    </Styles.Container>
  )
}

export default ShippingMethodLogistic
